import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M7.871 4.559l1.556.63a.54.54 0 01.334.54L9.57 7.503a.309.309 0 00.244.347l6.428 1.53a3.857 3.857 0 012.932 5.092 1.041 1.041 0 01-1.376.553l-3.986-1.633a.67.67 0 00-.604.064l-2.97 2.032a.579.579 0 01-.54 0l-1.774-.669a.565.565 0 01-.154-.964l2.005-1.569a.296.296 0 00.116-.296.295.295 0 00-.193-.244l-3.561-1.44a1.029 1.029 0 01-.617-1.286l1.684-4.204a.501.501 0 01.668-.257zM20.036 20.901H3.964a.964.964 0 010-1.928h16.072a.965.965 0 010 1.928z",
      fill: "#333"
    }
  )
);
export {
  e as default
};
